import { InfluencerCampaignPost } from '../../../models/influencer-campaign';
import { Router } from '@angular/router';
var CampaignPostItemComponent = /** @class */ (function () {
    function CampaignPostItemComponent(router) {
        this.router = router;
    }
    CampaignPostItemComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(CampaignPostItemComponent.prototype, "campaignInfluencerImpact", {
        get: function () {
            if (!this.post || !this.post.engagement || !this.post.reach) {
                return '0';
            }
            var engagement = this.post.engagement;
            var reach = this.post.reach;
            if (!reach || reach === 0 || !engagement || engagement === 0) {
                return '0';
            }
            var impact = (engagement * 100 / reach).toFixed(0);
            return impact;
        },
        enumerable: true,
        configurable: true
    });
    CampaignPostItemComponent.prototype.openCampaignPost = function () {
        if (this.campaignId) {
            return this.router.navigate(['dashboard', 'post', this.post.urlHash]);
        }
    };
    return CampaignPostItemComponent;
}());
export { CampaignPostItemComponent };



// WEBPACK FOOTER //
// ./src/app/fb-testing-page/campaign-post-item/campaign-post-item.component.ts.pre-build-optimizer.js